import { SDKVersion } from '@bimser/common';
import { importRemote } from 'module-federation-import-remote';
import { IModuleImporter } from './entities/IModuleImporter';

const currentSDKVersion: SDKVersion = '2';

const ModuleImporter = (version: SDKVersion): IModuleImporter<any> => {
	let SDK = () => {
		const url = `${getEnv()}/api/buildManager/formcontrols/${version}`;
		const scope = `SynergyVendorV${version}`;
		return {
			App: () =>
				importRemote({
					url,
					scope,
					module: 'App'
				}),
			Helpers: () =>
				importRemote({
					url,
					scope,
					module: 'Helpers'
				})
		};
	};

	const LATEST = () => {
		return {
			App: async () => {
				const { Runtime } = await import('@bimser/form-controls');

				return { default: Runtime.FormView };
			},
			Helpers: () => {
				return import('@bimser/form-controls');
			}
		};
	};

	if (!version) {
		throw new Error('SDK version is required!');
	}

	// const useSelfAsSDK =
	// 	version === currentSDKVersion && !localStorage.getItem('doNotUseSelfAsSDK');
	const useSelfAsSDK = false;
	const isDevelopment = process.env.NODE_ENV !== 'production';

	if (useSelfAsSDK || isDevelopment) {
		SDK = LATEST;
	}

	return {
		SDK
	};
};

const getEnv = () => {
	const origin = window.location.origin;
	const local = origin.endsWith('bimser.local') && origin !== 'https://synergy.bimser.local';
	return local ? 'https://dev.bimser.net' : window.location.origin;
};

export { ModuleImporter };
